export {
  getAuthClient,
  getAuthCookieHeader,
  getBetterAuthBaseUrl,
  getBetterAuthScheme,
  interactiveSignInDeadline,
} from "#auth-client";
export { resolveBetterAuthBaseUrl, syncBetterAuthBaseUrlEnv } from "#better-auth-base-url";
export {
  resolveBetterAuthInfraConnectionOptions,
  resolveBetterAuthKvIdentifyUrl,
} from "#better-auth-infra-options";
export {
  betterAuthSocialProviderAvailabilityQueryOptions,
  fetchBetterAuthSocialProviderAvailability,
} from "#fetch-better-auth-social-provider-availability";
export { useAuthSession } from "#use-auth-session";
export { useLocalAccount, useRecordSessionAccountEmail } from "#use-local-account";
export type { LocalAccount } from "#use-local-account-for-session";
export type { AuthSessionSnapshot, AuthSessionUser } from "#auth-session-snapshot";
export type { BetterAuthSocialProviderAvailability } from "#better-auth-social-provider-availability";
